//USER_MODULE
export const SET_USER = 'SET_USER';
export const SET_LOGGEDIN_STATUS = 'SET_LOGGEDIN_STATUS';

//INFOS_MODULE
export const SELECT_INFO = 'SELECT_INFO';
export const REMOVE_INFO_SELECTION = 'REMOVE_INFO_SELECTION';
export const CLEAR_INFO_SELECTIONS = 'CLEAR_INFO_SELECTIONS';
export const UPDATE_DISPLAYED_INFOS = 'UPDATE_DISPLAYED_INFOS';

//FILE_UPLOAD_MODULE
export const ADD_UPLOADING_FILE = 'ADD_UPLOADING_FILE';
export const REMOVE_UPLOADING_FILE = 'REMOVE_UPLOADING_FILE';
export const CLEAR_COMPLETED_STATUS_FILES = 'CLEAR_COMPLETED_STATUS_FILES';
export const UPDATE_UPLOAD_PROGRESS = 'UPDATE_UPLOAD_PROGRESS';

//AKTA_MODULE
export const UPDATE_DISPLAYED_AKTAS = 'UPDATE_DISPLAYED_AKTAS';
export const UPDATE_DISPLAYED_MODAL_AKTAS = 'UPDATE_DISPLAYED_MODAL_AKTAS';

//SESSION_MODULE
export const SET_SESSION_TIMER = 'SET_SESSION_TIMER';
export const SET_SESSION_LENGTH = 'SET_SESSION_LENGTH';
export const UPDATE_CURRENT_SESSION = 'UPDATE_CURRENT_SESSION';
